///<amd-module name="typeahead/core/logging/Element" />

import {ISuggestionResult, Suggestion, SuggestionCategory} from "typeahead/core/Suggestion";
import {Optional} from "typeahead/core/util/Optional";
import {ListItemType} from "../IListItem";

export class Element {
    private value: string = "";
    private mostRecentSelection: Optional<Suggestion> = Optional.empty<Suggestion>();
    private mostRecentInputValue: string = "";
    private essSuggestionCount: number = 0;
    private userHistorySuggestionCount: number = 0;
    private elementFocused: boolean = false;
    private suggestionShown: boolean = false;
    private suggestionSelected: boolean = false;

    constructor (private domElementId: string = "") {
        if (domElementId) {
            this.value = $("#" + domElementId).val() || "";
        }
    }

    public setElementFocused(): void {
        this.elementFocused = true;
    }

    public setSuggestionShown(suggestions: ISuggestionResult[]): void {
        this.suggestionShown = true;
        this.setSuggestionCount(suggestions);
    }

    public setSuggestionSelected(suggestion: Suggestion): void {
        this.suggestionSelected = true;
        this.mostRecentSelection = Optional.of(suggestion);
        this.value = suggestion.getDisplayText();
    }

    public setMostRecentInputValue(value: string): void {
        this.suggestionSelected = false;
        this.mostRecentInputValue = value;
        this.mostRecentSelection = Optional.empty<Suggestion>();
        this.value = value;
    }

    public isSuggestionShown(): boolean {
        return this.suggestionShown;
    }

    public isSuggestionSelected(): boolean {
        return this.suggestionSelected;
    }

    public getMostRecentInputValue(): string {
        return this.mostRecentInputValue;
    }

    public getEssSuggestionCount(): number {
        return this.essSuggestionCount;
    }

    public getUserHistorySuggestionCount(): number {
        return this.userHistorySuggestionCount;
    }

    public getMostRecentSelection(): Optional<Suggestion> {
        return this.mostRecentSelection;
    }

    public getVal(): string {
        return this.value;
    }

    private setSuggestionCount(suggestions: ISuggestionResult[]): void {
        this.userHistorySuggestionCount = 0;
        this.essSuggestionCount = 0;
        if (suggestions) {
            suggestions.forEach((suggestionResult: ISuggestionResult) => {
                if (ListItemType.Label !== suggestionResult.listItemType) {
                    switch (suggestionResult.category) {
                        case SuggestionCategory[SuggestionCategory.USERHISTORY]: {
                            this.userHistorySuggestionCount++;
                            break;
                        }
                        case SuggestionCategory[SuggestionCategory.GEOLOCATION]: {
                            break;
                        }
                        case SuggestionCategory[SuggestionCategory.GOOGLEMAPS]: {
                            break;
                        }
                        default : {
                            this.essSuggestionCount++;
                        }
                    }
                }
            });
        }
    }
}
